import React from 'react';
import { useTranslate } from '../../../services/translate';
import { UiBoxProps, UiBox } from '@open-stack/ui';

interface Props extends UiBoxProps {
    id: string;
    params?: any;
}

export function XTranslate({ id, params }: Props) {
    const { t } = useTranslate();
    return <UiBox element="span" dangerouslySetInnerHTML={{ __html: t(id, params) }} />;
}
